var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("section", { staticClass: "box-item" }, [
      _c("h3", { staticClass: "approve_title" }, [
        _vm._v(_vm._s(_vm.$t("FIELD.COMPANY.INFORMATION")))
      ]),
      _vm._v(" "),
      _c("table", { staticClass: "approve_table" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("tbody", [
          _c("tr", [
            _c("th", [
              _vm._v(
                _vm._s(_vm.$t("FIELD.GLOBAL.ID")) +
                  "(" +
                  _vm._s(_vm.$t("BUTTON.GLOBAL.EMAIL")) +
                  ")"
              )
            ]),
            _vm._v(" "),
            _c("td", [_vm._v(_vm._s(_vm.data.email))]),
            _vm._v(" "),
            _c("th", [_vm._v(_vm._s(_vm.$t("FIELD.EUR.FIRST.NAME")))]),
            _vm._v(" "),
            _c("td", [_vm._v(_vm._s(_vm.data.contactFirstName))])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("th", [_vm._v(_vm._s(_vm.$t("FIELD.PROFILE.COMPANY.NAME")))]),
            _vm._v(" "),
            _c("td", [_vm._v(_vm._s(_vm.data.companyName))]),
            _vm._v(" "),
            _c("th", [_vm._v(_vm._s(_vm.$t("FIELD.EUR.LAST.NAME")))]),
            _vm._v(" "),
            _c("td", [_vm._v(_vm._s(_vm.data.contactLastName))])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("th", [
              _vm._v(_vm._s(_vm.$t("FIELD.COMPANY.REGISTRATION.NUMBER")))
            ]),
            _vm._v(" "),
            _c("td", [_vm._v(_vm._s(_vm.data.companyRegNo))]),
            _vm._v(" "),
            _c("th", [_vm._v(_vm._s(_vm.$t("FIELD.CONTACT.PHONE.NUMBER")))]),
            _vm._v(" "),
            _c("td", [_vm._v(_vm._s(_vm.data.phoneNumber))])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("th", [_vm._v(_vm._s(_vm.$t("FIELD.EUR.COMP.ADDR")))]),
            _vm._v(" "),
            _c("td", [_vm._v(_vm._s(_vm.data.companyAddress))]),
            _vm._v(" "),
            "C480" === _vm.corpCd
              ? _c("th", [_vm._v(_vm._s(_vm.$t("FIELD.EUR.APE.CODES")))])
              : _vm._e(),
            _vm._v(" "),
            "C480" === _vm.corpCd
              ? _c("td", [_vm._v(_vm._s(_vm.data.apeCodes))])
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("th", [_vm._v(_vm._s(_vm.$t("FIELD.POSTAL.CODE")))]),
            _vm._v(" "),
            _c("td", [_vm._v(_vm._s(_vm.data.zipCode))]),
            _vm._v(" "),
            _c("th", [_vm._v(_vm._s(_vm.$t("FIELD.INSURANCE.POLICY")))]),
            _vm._v(" "),
            0 < parseInt(_vm.data.fileLength1)
              ? _c("td", [
                  _c(
                    "a",
                    {
                      staticClass: "link_attch",
                      attrs: { href: "javascript:" },
                      on: {
                        click: function($event) {
                          return _vm.downloadFile("1", _vm.data.fileName1)
                        }
                      }
                    },
                    [
                      _c("span", { staticClass: "ico_attach" }),
                      _vm._v(
                        _vm._s(_vm.data.fileName1) +
                          "\n                        "
                      )
                    ]
                  )
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("th", [_vm._v(_vm._s(_vm.$t("FIELD.COMPANY.WEBSITE.ADDRESS")))]),
            _vm._v(" "),
            _c("td", [_vm._v(_vm._s(_vm.data.companyWebAddress))]),
            _vm._v(" "),
            _c("th", [
              _vm._v(_vm._s(_vm.$t("FIELD.COMPANY.REGISTRATION.FILE")))
            ]),
            _vm._v(" "),
            0 < parseInt(_vm.data.fileLength2)
              ? _c("td", [
                  _c(
                    "a",
                    {
                      staticClass: "link_attch",
                      attrs: { href: "javascript:" },
                      on: {
                        click: function($event) {
                          return _vm.downloadFile("2", _vm.data.fileName2)
                        }
                      }
                    },
                    [
                      _c("span", { staticClass: "ico_attach" }),
                      _vm._v(
                        _vm._s(_vm.data.fileName2) +
                          "\n                        "
                      )
                    ]
                  )
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("tr")
        ])
      ])
    ]),
    _vm._v(" "),
    _c("section", [
      _c("h3", { staticClass: "approve_title" }, [
        _vm._v(_vm._s(_vm.$t("SUBTITLE.AUTHREQ.REQUEST")))
      ]),
      _vm._v(" "),
      _c("table", { staticClass: "approve_table" }, [
        _vm._m(1),
        _vm._v(" "),
        _c("tbody", [
          _c("tr", [
            _c("th", [_vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.REQUEST.DATE")))]),
            _vm._v(" "),
            _c("td", [_vm._v(_vm._s(_vm.data.REQ_DT))])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("th", [_vm._v(_vm._s(_vm.$t("FIELD.REQUEST.TYPE")))]),
            _vm._v(" "),
            _c("td", [_vm._v(_vm._s(_vm.data.REQ_TYPE_NM))])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("th", [_vm._v(_vm._s(_vm.$t("FIELD.REQUEST.MODEL.CODE")))]),
            _vm._v(" "),
            _c("td", [_vm._v(_vm._s(_vm.data.SELECT_MODEL_CODE))])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("th", [_vm._v(_vm._s(_vm.$t("FIELD.MAJOR.PRODUCT.CATEGORY")))]),
            _vm._v(" "),
            _c("td", [_vm._v(_vm._s(_vm.data.CATE_MAIN_NM))])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("th", [_vm._v(_vm._s(_vm.$t("FIELD.SUB.PRODUCT.CATEGORY")))]),
            _vm._v(" "),
            _c("td", [_vm._v(_vm._s(_vm.data.CATE_SUB_NM))])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("th", [_vm._v(_vm._s(_vm.$t("FIELD.REQUESTED.CONTENTS")))]),
            _vm._v(" "),
            _c("td", [_vm._v(_vm._s(_vm.data.SEL_CNTNTS))])
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "btn_wrap_full topLine" }, [
      _c(
        "a",
        {
          staticClass: "btn_white",
          attrs: { href: "javascript:" },
          on: { click: _vm.goListBack }
        },
        [
          _vm._v(
            "\n            " +
              _vm._s(_vm.$t("BUTTON.GLOBAL.LIST")) +
              "\n        "
          )
        ]
      ),
      _vm._v(" "),
      _vm.btnShow()
        ? _c("div", { staticClass: "btn_right" }, [
            _c(
              "a",
              {
                staticClass: "btn_red",
                attrs: { href: "javascript:" },
                on: {
                  click: function($event) {
                    return _vm.btnClick("Reject")
                  }
                }
              },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("BUTTON.GLOBAL.REJECT")) +
                    "\n            "
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "btn_blue",
                attrs: { href: "javascript:" },
                on: {
                  click: function($event) {
                    return _vm.btnClick("Approve")
                  }
                }
              },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("BUTTON.APPROVAL.APPROVE")) +
                    "\n            "
                )
              ]
            )
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("colgroup", [
      _c("col", { attrs: { width: "270px" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "*" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "270px" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "*" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("colgroup", [
      _c("col", { attrs: { width: "270px" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "*" } })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-dbdcb5a6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dbdcb5a6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/skpComponents/view/basis/eur/admin/RequestManagerDetail.vue
// module id = Kiir
// module chunks = 0